import * as React from 'react';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import HorizontalBarTwoSeries from '../HorizontalBarTwoSeries';
import ClaimList from 'components/claims-list/claimList';
import { claimsActions } from '../../../store/claims';
import * as models from '../../../models'
import '../../../assets/styles/myDashboard.css';
import SimpleMetricCard from '../SimpleMetricCard';
import TrendMetricCard from '../TrendMetricCard';
import { FolderOpenOutlined, ExclamationCircleOutlined, CloseCircleOutlined, StockOutlined } from '@ant-design/icons';
import { dashboardActions } from 'store/dashboard';
import VerticalBarChart from '../VerticalBarChart';
import services from '../../../services';
import { MetricType } from 'models/enums';

type ChartType = "line" | "area" | "bar" | "pie" | "donut" | "radialBar" | "scatter" | "bubble" | "heatmap" | "candlestick" | "boxPlot" | "radar" | "polarArea" | "rangeBar" | "rangeArea" | "treemap" | undefined;  
interface Props extends PropsFromRedux {
}

interface State {
}

class Dashboard extends React.PureComponent<Props, State> {
    public state = {
    }

    getOpenClaimsByCompany = (companyName: string) => {
            const claimsRequest: models.ClaimsRequest = {
                ...models.defaultClaimsRequest, 
                insCompany: companyName,
                status: "Open,Reopened"
            }
            console.log(claimsRequest); 
            this.props.requestClaims(claimsRequest); 
            services.router.goto(services.router.url.claimList); 
        }

    public componentDidMount() {
        this.props.getAdminDashboard(); 
        const claimRequest: models.ClaimsRequest = {
            ...models.defaultClaimsRequest,
            status: "Open,Reopened",
        }        
        this.props.requestClaims(claimRequest);
    }

    public openAssignQueue = () => {
        const request: models.ClaimsRequest = {
            ...models.defaultClaimsRequest, 
            fieldAdjuster: "ASSIGN"
        }
        this.props.requestClaims(request); 
        services.router.goto(services.router.url.claimList); 
    }

    public handleOpenCurrentClick = () => {
        this.props.requestClaims({...models.defaultClaimsRequest, status: "Open, Reopened" }); 
        services.router.goto(services.router.url.claimList); 
    }

    public handleYtdClosedClick = () => {
        this.props.requestClaims({
            ...models.defaultClaimsRequest, 
            closedDateFrom: new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0],
            closedDateTo: new Date().toISOString().split('T')[0]
        }); 
        //services.router.goto(services.router.url.claimList); 
        services.router.gotoWithState(services.router.url.claimList, {referrer: "Dashboard"}); 
    }

    public handleYtdOpenClaims = () => {
        this.props.requestClaims({
            ...models.defaultClaimsRequest, 
            receivedDateFrom: new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0],
            receivedDateTo: new Date().toISOString().split('T')[0]
        }); 
        services.router.goto(services.router.url.claimList); 
    }

    public render() {
        const { data } = this.props;         

        return ( 
            <>           
                <div style={{height: "200px"}}>
                    <Row className="metric-group">
                        <Col style={{height: "100%"}}>
                            <TrendMetricCard
                                title={data?.ytdClaimsOpened?.name || ""}
                                value={data?.ytdClaimsOpened?.metric || 0}
                                type={data?.ytdClaimsOpened?.type || MetricType.Count}
                                icon={<StockOutlined />}
                                trend={data?.ytdClaimsOpened?.trend || 0}
                                handleClick={this.handleYtdOpenClaims}    
                                toolTipText='Claims received this year.  Trend arrow shows the comparison to last year at this date.'    
                                shortValue                        
                            />
                        </Col>
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.ytdClaimsClosed?.name || ""}
                                value={data?.ytdClaimsClosed?.metric || 0}
                                type={data?.ytdClaimsClosed?.type || MetricType.Count}
                                icon={<CloseCircleOutlined />}  
                                handleClick={this.handleYtdClosedClick}  
                                toolTipText='Count of claims closed YTD'                        
                                shortValue
                            />
                        </Col>                    
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.openClaimCount?.name || ""}
                                value={data?.openClaimCount?.metric || 0}
                                type={data?.openClaimCount?.type || MetricType.Count}
                                icon={<FolderOpenOutlined />}      
                                handleClick={this.handleOpenCurrentClick}    
                                toolTipText='Count of claims in an open/reopened status'                  
                            />
                        </Col>
                        <Col style={{height: "100%"}}>
                            <SimpleMetricCard
                                title={data?.assignQueue?.name || ""}
                                value={data?.assignQueue?.metric || 0}
                                type={data?.assignQueue?.type || MetricType.Count}
                                icon={<ExclamationCircleOutlined />}                            
                                handleClick={this.openAssignQueue}
                                toolTipText='Count of claims awaiting assignment'
                            />
                        </Col>                                                               
                    </Row>
                </div>
                <Row className="dash-cards-row" style={{height: "400px"}}>                                            
                    <Col as={Card}>
                        <HorizontalBarTwoSeries
                            categories={data?.monthlyClaims?.series1?.categories}
                            columnTitle='Opened'
                            seriesColumn={data?.monthlyClaims?.series1?.data}
                            seriesLine={data?.monthlyClaims?.series2?.data}
                            seriesType='number'
                            lineTitle='Closed'
                            title='Monthly Claim Activity'
                        /> 
                    </Col>
                    <Col as={Card}>
                        <VerticalBarChart
                            categories={data?.openClaimsByCarrier?.categories || []}
                            clickEvent={(e) => this.getOpenClaimsByCompany(e)}
                            series={data?.openClaimsByCarrier?.data || []}
                            seriesLabel=""
                            title={data?.openClaimsByCarrier?.name || ""}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ClaimList
                            title="Most Recent Claims"
                            isSortable={false}
                            isSelectable={false}
                        />
                    </Col>
                </Row>            
            </>
        );
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
    data: state.dashboards.dashboards.adminDashbard, 
    claimsListResponse: state.claims.search.claimsListResponse,
    claimsRequest: state.claims.search.claimsRequest,
    isLoading: state.claims.search.isClaimsListLoading,
    isClaimsListDownloading: state.claims.search.isClaimsListDownloading,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            getAdminDashboard: dashboardActions.requestAdminDashboard, 
            requestClaims: claimsActions.requestClaims,
            requestClaimCSV: claimsActions.requestClaimCSV,
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(Dashboard); 
